import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconField(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M5 7a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H5v2ZM3 17a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1v-3ZM17 5a1 1 0 1 1 0-2h3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V5h-2ZM19 17a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h2v-2ZM9 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-1v6h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1V9h-1a1 1 0 0 1-1-1Z"
      />
    </BaseIcon>
  );
}
